import { z } from 'zod';

export const ReasonLandRegisterQuerySchema = z.object({
  idRealEstate: z.number(),
  Reason: z.string(),
});

export type ILandRegisterQueryRelationshipData = z.infer<
  typeof ReasonLandRegisterQuerySchema
>;
